import { Directive, ElementRef, Input, OnChanges, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

/** Charge une image protégée (vignette, logo, signature) avec le jeton : <img [bayAuthSrc]="url"> */
@Directive({ selector: 'img[bayAuthSrc]' })
export class AuthSrcDirective implements OnChanges, OnDestroy {
  @Input() bayAuthSrc?: string | null;
  private url?: string;
  private sub?: Subscription;

  constructor(private el: ElementRef<HTMLImageElement>, private http: HttpClient) {}

  ngOnChanges(): void {
    this.liberer();
    // Nouvelle adresse : l'échec d'un chargement précédent (ex. aucun logo avant téléversement) ne doit pas masquer celle-ci
    this.el.nativeElement.classList.remove('bay-img-erreur');
    if (!this.bayAuthSrc) { this.el.nativeElement.removeAttribute('src'); return; }
    this.sub = this.http.get(this.bayAuthSrc, { responseType: 'blob' }).subscribe({
      next: b => { this.url = URL.createObjectURL(b); this.el.nativeElement.src = this.url; },
      error: () => this.el.nativeElement.classList.add('bay-img-erreur')
    });
  }

  private liberer(): void {
    this.sub?.unsubscribe();
    if (this.url) { URL.revokeObjectURL(this.url); this.url = undefined; }
  }

  ngOnDestroy(): void { this.liberer(); }
}
